import React from "react";
import { Col, Row, Typography } from "antd";
import AvatarDefault from "@assets/images/ava.svg";
import PhoneNumber from "@components/PhoneNumber";
import AuctionTime from "@components/AuctionTime";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

const BitItem = ({ history }) => {
  const { t } = useTranslation();
  return (
    <div className="list-item">
      <Row gutter={[4, 0]} justify="space-between" align="middle">
        <Col xs={17} md={16} lg={17} xl={17}>
          <div className="list-item-wrapper">
            <div>
              <Text className="list-item-image" style={{ backgroundImage: `url(${history.image || AvatarDefault})` }} />
            </div>
            <div className="list-item-user">
              <Text className="list-item-name">{history?.name}</Text>
              <PhoneNumber
                value={history?.isdn}
                className="list-item-phone"
              />
              <AuctionTime value={history?.auction_time} />
            </div>
          </div>
        </Col>
        <Col xs={7} md={8} lg={7} xl={7}>
          <Title level={5} className="list-item-label">{t("product.bid_price")}</Title>
          <Text className="list-item-price">{t("currency_sign")} {history?.price}</Text>
        </Col>
      </Row>
    </div>
  );
};

export default BitItem;

